/**
 * Utility to redirect to an app with JWT from localStorage
 * @param {Object} api - The API hook instance (not used with this approach)
 * @param {string} appUrl - The app URL to redirect to
 * @param {string} appDomain - The domain of the app to redirect to
 */
const redirectToAppWithSession = async (api, appUrl, appDomain) => {
	try {
	  // Get the JWT token directly from localStorage
	  const accessToken = localStorage.getItem('accessToken');

	  if (accessToken) {
		console.log(`Using access token from localStorage. Redirecting to app...`);

		// Special case for mateza-tables - use query parameters with JWT
		if (appDomain === 'mateza-tables.vercel.app') {
		  const redirectUrl = `${appUrl}?jwt=${accessToken}`;
		  window.open(redirectUrl, '_blank');
		} else if (appDomain === 'foodcostberekenen.be') {
		  // Special case for foodcost - don't add the hash
		  window.location.href = appUrl;
		} else {
		  // For all other apps, add the JWT as a hash parameter
		  const redirectUrl = `${appUrl}#jwt=${accessToken}`;
		  window.location.href = redirectUrl;
		}
	  } else {
		console.error('No access token found in localStorage');
		// Fallback: redirect without token
		if (appDomain === 'mateza-tables.vercel.app') {
		  // For mateza-tables, fallback to tasks page
		  window.open('https://mateza-tables.vercel.app/tasks', '_blank');
		} else {
		  window.location.href = appUrl;
		}
	  }
	} catch (error) {
	  console.error('Error during redirect:', error);
	  // Fallback: redirect without token
	  if (appDomain === 'mateza-tables.vercel.app') {
		window.open('https://mateza-tables.vercel.app/tasks', '_blank');
	  } else {
		window.location.href = appUrl;
	  }
	}
  };

  export default redirectToAppWithSession;